import { TagKey } from '@cof/tag-catalog-fs-esign-mfe';
import { stratum } from '../../../../constants/stratum.js';
import { DebugService } from '../debug.service.js';
import { REFI_ESIGN_CONST } from '../../../../constants/app.constants.js';
import { SessionService } from '../../../core/services/session/session.service.js';
import { ApiService } from '../../../core/services/api/api.service.js';

class _ETitleDetailsService {
  constructor() {
    this.debugService = new DebugService('ETitleDetailsService');
  }

  /**
   * Fetches ETitle Details from BFF
   * @method getETitleDetails
   * @async
   * @returns {Promise<ETitleDetails | null>}
   */
  async getETitleDetails() {
    let eTitleDetails = null;
    try {
      const { eAppId } = SessionService.session;
      const url = `${REFI_ESIGN_CONST.ESIGN_BFF_URL}/${eAppId}/document-type`;
      const opts = {
        headers: {
          Accept: 'application/json;v=2',
        },
      };
      eTitleDetails = await ApiService.get(url, opts);
      stratum.publishTag(TagKey.ETITLE_ETITLE_DETAILS_API_SUCCESSFUL);
    } catch (ex) {
      this.debugService.error('Unable to load ETitle Details', ex);
      stratum.publishTag(TagKey.ETITLE_ETITLE_DETAILS_API_FAILED);
    }
    return eTitleDetails;
  }
}

export const ETitleDetailsService = new _ETitleDetailsService();
